var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckCircle = function SvgCheckCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66504 16C13.0833 16 16.665 12.4183 16.665 8C16.665 3.58172 13.0833 0 8.66504 0C4.24676 0 0.665039 3.58172 0.665039 8C0.665039 12.4183 4.24676 16 8.66504 16Z",
    fill: "#03606A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61759 11.1899C7.52844 11.19 7.44017 11.1723 7.35794 11.1379C7.27571 11.1034 7.20116 11.053 7.13865 10.9894L4.65971 8.47098C4.53482 8.34368 4.46562 8.17197 4.46732 7.99364C4.46902 7.8153 4.54148 7.64495 4.66878 7.52006C4.79608 7.39516 4.96779 7.32594 5.14612 7.32764C5.32446 7.32934 5.49483 7.40182 5.61972 7.52912L7.59625 9.54086L11.6933 5.02886C11.8147 4.90342 11.9802 4.83015 12.1547 4.82456C12.3291 4.81897 12.499 4.88149 12.6281 4.9989C12.7573 5.1163 12.8358 5.27938 12.8468 5.4536C12.8579 5.62782 12.8007 5.79951 12.6874 5.93233L8.11359 10.9702C8.05228 11.0379 7.97782 11.0924 7.89474 11.1304C7.81166 11.1683 7.72171 11.189 7.63039 11.191L7.61759 11.1899Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-circle.d9d283ba.svg";
export { ForwardRef as ReactComponent };